module.exports = __webpack_public_path__ + "static/img/05.內部稽核組織_EN.81a2f31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/05.內部稽核組織_EN.jpg
// module id = Wskz
// module chunks = 1